// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3HPmr","questions":"styles_questions__20TzV","footer":"styles_footer__3-FCE"};